import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { RadioBulletMarker } from '../radio-bullet-marker';
import styles from './ComplexRadioBullet.css';

const IRenderable = PropTypes.oneOfType([
  PropTypes.element,
  PropTypes.node,
]);

const IPropTypes = {
  body: IRenderable,
  onClick: PropTypes.func,
  rightContent: IRenderable,
  selected: PropTypes.bool,
  topMessage: IRenderable,
};

const defaultProps = {
  body: '',
  onClick: () => {},
  rightContent: '',
  selected: false,
  topMessage: '',
};

const ComplexRadioBullet = props => (
  <div className={[styles.container, props.selected ? styles.selected : ''].join(' ')}>
    <div className={styles.radioButtonContainer}>
      <button
        className={styles.radioButton}
        onClick={props.onClick}
      >
        <RadioBulletMarker
          selected={props.selected}
        />
      </button>
    </div>
    <div className={styles.mainContent}>
      <button
        className={styles.topMessage}
        onClick={props.onClick}
      >
        {props.topMessage}
      </button>
      {props.body}
    </div>
    <div className={styles.rightContent}>
      {props.rightContent}
    </div>
  </div>
);

ComplexRadioBullet.propTypes = IPropTypes;
ComplexRadioBullet.defaultProps = defaultProps;

const ObservedComplexRadioBullet = observer(ComplexRadioBullet);

export { ObservedComplexRadioBullet as ComplexRadioBullet };



// WEBPACK FOOTER //
// ./src/common/complex-radio-bullet/ComplexRadioBullet.jsx